import React from 'react';
import { styled } from '@mui/material/styles';
import { ISearchCategory } from 'src/hooks/useMenuSearch';
import { IEnrichedProduct, IProduct, ProductGroup, isProductGroup } from './model/Menu';
import { Box, ListItemText } from '@mui/material';
import { MenuProduct } from './MenuProduct';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';

const PREFIX = 'MenuSearchCategory';

const classes = {
    titleCategory: `${PREFIX}titleCategory`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.titleCategory}`]: {
        marginBottom: theme.spacing(1),
        fontWeight: 'bold',
        color: theme.palette.titleTextColour
    }
}));

interface MenuSearchCategoryProps {
    category: ISearchCategory;
    onProductSelect: (product: IEnrichedProduct | ProductGroup, categoryId: string) => void;
}

export const MenuSearchCategory: React.FC<React.PropsWithChildren<MenuSearchCategoryProps>> = ({
    category,
    onProductSelect
}) => {
    const { items } = useSelector((state: ApplicationState) => state.basket);
    const { menu } = useSelector((state: ApplicationState) => state.menu);
    const handleProductSelect = React.useCallback(
        (product: IEnrichedProduct | ProductGroup) => {
            onProductSelect(product, category.id);
        },
        [category.id, onProductSelect]
    );
    const renderProduct = React.useCallback(
        (item: IProduct) => {
            const itemQuantity = items.reduce((acc, basketItem) => {
                if (
                    category.id === basketItem.categoryId &&
                    ((isProductGroup(item) &&
                        item.products.map(product => product.id).includes(basketItem.productId)) ||
                        item.id === basketItem.productId)
                ) {
                    return acc + basketItem.quantity;
                }
                return acc;
            }, 0);
            return (
                <MenuProduct
                    key={item.id}
                    item={item}
                    menu={menu}
                    enableSwipe={false}
                    quantity={itemQuantity}
                    onClick={handleProductSelect}
                />
            );
        },
        [items, menu, handleProductSelect, category.id]
    );
    return (
        <StyledBox>
            <ListItemText
                primary={category.title}
                slotProps={{
                    primary: {
                        className: classes.titleCategory,
                        variant: 'h5'
                    }
                }}
            />
            {category.products.map(renderProduct)}
        </StyledBox>
    );
};
